// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__21Y3J","inner":"Footer_inner__2X_5T"};